import { createStore, compose, applyMiddleware } from 'redux'
// se encarga de trabajar en concordancia con las promises  promiseMiddleware
import promiseMiddleware from "redux-promise";
import { currentEnviroment } from '../utils/environmentConfig.json';
import reducers from './../reducers'

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
// const reducers = state  => state

const composeEnhancers =
  (currentEnviroment !== 'CORE-PROD' &&
    typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;
export const store = createStore(reducers, {},
     composeEnhancers(applyMiddleware(promiseMiddleware)))
